import { type LinkExternal as LinkExternalType } from '@/sanity/schemaTypes/objects/link/linkExternalType';
import Link from 'next/link';
import { ReactNode } from 'react';

function LinkExternal({
  link,
  className,
  children
}: {
  link: LinkExternalType;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <Link
      href={link.url}
      className={className}
      rel="noopener noreferrer"
      target={link.newWindow ? '_blank' : '_self'}
    >
      {children}
    </Link>
  );
}

export default LinkExternal;
